import { Component, Input } from '@angular/core';
import { ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent {
  @Input() single!: any[] | null;
  // chart options
  animations = true;
  colorScheme = {
    name: 'cool',
    selectable: true,
    group: ScaleType.Linear,
    domain: ['#BE6B83', '#417BAC', '#795D7C', '#4A5595', '#ED8F6D', '#834072', '#8B6681']
  };
}
